import { Workspace } from '@anm/api/modules/team';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { appMetaSelectors } from '../store/modules/appMeta';
import { userSelectors } from '../store/modules/user';
import { videoFolderActions, videoFolderSelectors } from '../store/modules/videoFolder';

let prevWorkspace: Workspace;
const useFolderTree = () => {
  const dispatch = useDispatch();

  const user = useSelector(userSelectors.selectUser);
  const isProfilePending = useSelector(userSelectors.selectUserPending);
  const folderTree = useSelector(videoFolderSelectors.selectFolderTree);
  const workspace = useSelector(appMetaSelectors.selectWorkspace);

  useEffect(() => {
    if ((folderTree && prevWorkspace === workspace) || !user.profile || isProfilePending) return;
    prevWorkspace = workspace;
    dispatch(videoFolderActions.fetchFolderTree(user.profile?.username));
  }, [folderTree, user.profile?.userId, isProfilePending, workspace]);

  return folderTree;
};

export default useFolderTree;
